import React, { createContext, useContext, useState, useEffect } from 'react'
import { SupabaseClient } from '@supabase/supabase-js'
import { Database } from '../types/database.types'
import { supabase } from '../lib/supabase'

interface SupabaseContextType {
  supabase: SupabaseClient<Database>
  isConnected: boolean
}

const SupabaseContext = createContext<SupabaseContextType | undefined>(undefined)

export function SupabaseProvider({ children }: { children: React.ReactNode }) {
  const [isConnected, setIsConnected] = useState(false)

  useEffect(() => {
    // Check connection
    const checkConnection = async () => {
      try {
        const { error } = await supabase.from('user_profiles').select('count').limit(1)
        setIsConnected(!error)
      } catch {
        setIsConnected(false)
      }
    }

    checkConnection()

    // Set up auth state listener
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, _session) => {
        console.log('Auth state changed:', event)
        if (event === 'SIGNED_IN') {
          setIsConnected(true)
        }
      }
    )

    return () => {
      authListener?.subscription.unsubscribe()
    }
  }, [])

  return (
    <SupabaseContext.Provider value={{ supabase: supabase as SupabaseClient<Database>, isConnected }}>
      {children}
    </SupabaseContext.Provider>
  )
}

export function useSupabase() {
  const context = useContext(SupabaseContext)
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider')
  }
  return context
}